import { z } from "zod"
import {
  ApiSubscriptionSchema,
  AvailablePlansSchema,
  CancelPlanReqSchema,
  NewCouponSchema,
  SubscriptionIdSchema,
  UpgradePlanReqSchema,
} from "./subscription.schema"

export enum SubscriptionModeEnum {
  Subscription = "subscription",
  Contract = "contract",
}

export enum SubscriptionTypeEnum {
  Normal = "normal",
  Api = "api",
}

export enum SubscriptionSettingModeEnum {
  Free = "free",
  Change = "change",
  Cancellation = "cancellation",
}

export enum SubscriptionStateEnum {
  Active = "Active",
  MarkedToBeInactive = "MarkedToBeInactive", // Free 플랜으로 변경 예정
  MarkedToBeStarter = "MarkedToBeStarter", // Starter 플랜으로 변경 예정
  MarkedToBeAdvanced = "MarkedToBeAdvanced", // Advanced 플랜으로 변경 예정
  Inactive = "Inactive",
}

export enum ContractStatusEnum {
  Active = "Active",
  ForceTerminated = "Terminated",
  Expired = "Expired",
}

export enum TierIdEnum {
  Inactive = "Inactive",
  Starter = "Starter",
  Advanced = "Advanced",
  Ultimate = "Ultimate",
}

export enum GradeStatusEnum {
  Upgrade = "upgrade",
  Downgrade = "downgrade",
  Same = "same",
  Free = "free",
  PaymentMethodChanged = "paymentMethodChanged",
}

export enum ApiSubscriptionStateEnum {
  Active = "Active",
  Inactive = "Inactive",
  MarkedToBeInactive = "MarkedToBeInactive",
}

// The server's ApiTierId. Internal is granted to staff for free and never billed.
export enum ApiTierIdEnum {
  Individual = "Individual",
  TeamStart = "TeamStart",
  TeamGrow = "TeamGrow",
  TeamScale = "TeamScale",
  TeamEnterprise = "TeamEnterprise",
  Internal = "Internal",
}

export enum UsageTypeEnum {
  Private = "private",
  Public = "public",
}

export enum BillingChannelEnum {
  Internal = "internal",
  AzureMarketplace = "azure_marketplace",
}

export type AvailablePlans = z.infer<typeof AvailablePlansSchema>
export type UpgradePlanReq = z.infer<typeof UpgradePlanReqSchema>
export type CancelPlanReq = z.infer<typeof CancelPlanReqSchema>
export type Coupon = CouponForm & { createDt: string }
export type SubscriptionId = z.infer<typeof SubscriptionIdSchema>
export type ApiSubscription = z.infer<typeof ApiSubscriptionSchema>
export type CouponForm = z.infer<typeof NewCouponSchema>
